import { React } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { List } from '@digsup/components-list';
import { Text } from '@digsup/components-text';
import IconReach from './assets/reach.svg';
import IconSearch from './assets/search.svg';
import IconPrivacy from './assets/privacy.svg';

const featuresIcons = {
  reach: IconReach,
  search: IconSearch,
  privacy: IconPrivacy,
};

export const Features = ({ children }) => (
  <div className="u-padding-right-xlarge u-padding-left-xlarge">
    <List spacing="xlarge">{children}</List>
  </div>
);

Features.propTypes = {
  children: PropTypes.any,
};

export const FeaturesItem = ({ icon, children }) => (
  <List.Item>
    <List spacing="large" display="flex" nowrap>
      {icon && (
        <List.Item>
          {typeof icon === 'string' ? <img src={featuresIcons[icon]} /> : icon}
        </List.Item>
      )}
      <List.Item>
        <Text size="6xs" color="theme-descriptive" align="start">
          {children}
        </Text>
      </List.Item>
    </List>
  </List.Item>
);

FeaturesItem.propTypes = {
  icon: PropTypes.any,
  children: PropTypes.any,
};
